import React from "react";
import styled from "styled-components";

import Contain from "./contain";
import IPhone from "./iphone";
import Portal from "./portal";
import Form from "./form-cta";

const Section = styled.section`
  padding: 5rem 1rem;
  position: relative;
  z-index: 1;
`;

const QuickpageContain = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 0 5rem;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  position: relative;
  z-index: 1;

  @media (max-width: 75rem) {
    flex-direction: column;
    align-items: center;
  }
`;

const Col = styled.div`
  max-width: 23rem;
`;

const Card = styled.div`
  background: #f7fafc;
  margin: 0 0 1.5rem;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;

  @media (min-width: 50rem) {
    min-height: 10rem;
  }

  ${props =>
    props.active &&
    `
    background: #FFFFFF;
    box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.1);
  `}

  &:hover {
    background: #ffffff;
  }
`;

const Body = styled.div`
  padding-left: 1rem;
`;

const Heading = styled.h2`
  font-size: 1.2rem;
  margin: 0;
  padding: 0 0 0.5rem;
  color: #4a5568;
`;

const Description = styled.p`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  color: #718096;
  font-weight: 400;
`;

const Icon = styled.img``;

const CardForm = styled.div`
  border: 2px dashed #a0aec0;
  box-sizing: border-box;
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: center;
`;
const IconForm = styled.img``;

const FormHeading = styled.h3`
  font-weight: 500;
  font-size: 1.2rem;
  text-align: center;
  letter-spacing: 0.03em;
  color: #4a5568;
  margin: 0 0 1rem;
`;

const FormCTA = styled.button`
  background: #e9d8fd;
  border-radius: 50rem;
  padding: 1rem;
  border: 0;
  font-size: 1.2rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: #805ad5;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;

  &:hover {
    background: #d6bcfa;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Slide = styled.div`
  margin: 0 0 2rem;

  > div {
    z-index: 2;
  }
  @media (min-width: 75rem) {
    position: absolute;
    top: -4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
  }
`;

const ScrollContainer = styled.div`
  width: 100%;
  padding: 0 0 1rem;
`;

const ScrollMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow-x: auto;
  padding: 1rem 1rem 2rem;
  margin: 0 -2rem;

  > div {
    flex-shrink: 0;
    max-width: 360px;
    margin: 0 1rem 0 0;
    min-height: 160px;
  }
`;

export default class QuickpageHero extends React.Component {
  state = {
    slides: [
      {
        id: 0,
        url:
          "https://quickpage.io/static/screenshot-page-bec936f66075a3a7949d8426351d2647.png",
        active: true
      },
      {
        id: 1,
        url:
          "https://quickpage.io/static/screenshot-page-bec936f66075a3a7949d8426351d2647.png"
      },
      {
        id: 2,
        url:
          "https://quickpage.io/static/screenshot-page-bec936f66075a3a7949d8426351d2647.png"
      },
      {
        id: 3,
        url:
          "https://quickpage.io/static/screenshot-page-bec936f66075a3a7949d8426351d2647.png"
      },
      {
        id: 4,
        url:
          "https://quickpage.io/static/screenshot-page-bec936f66075a3a7949d8426351d2647.png"
      }
    ],
    activeSlide: {
      id: 0,
      url:
        "https://quickpage.io/static/screenshot-page-bec936f66075a3a7949d8426351d2647.png",
      active: true
    },
    visible: false,
    width: null
  };

  componentDidMount() {
    this.setState({ width: window.innerWidth });
  }

  setActive = id => {
    const newSlides = this.state.slides.map(s => {
      s.active = false;
      if (s.id === id) {
        s.active = true;
      }

      return s;
    });
    const newActiveSlide = newSlides.find(s => s.id === id);
    this.setState({
      slides: newSlides,
      activeSlide: newActiveSlide
    });
  };

  renderCardsLeft() {
    const { activeSlide } = this.state;
    return (
      <>
        <Card active={activeSlide.id === 0} onClick={() => this.setActive(0)}>
          <Icon
            src="data:image/svg+xml,%3Csvg width='36' height='38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M25.456 27.305a14.538 14.538 0 003.13-3.156 14.119 14.119 0 002.02-3.977c.472-1.45.707-2.982.715-4.613-.008-1.693-.264-3.289-.771-4.78a14.271 14.271 0 00-2.173-4.073 14.357 14.357 0 00-3.352-3.158 15.612 15.612 0 00-4.31-2.04c-1.583-.478-3.263-.72-5.053-.728-1.791.007-3.471.243-5.053.721a15.602 15.602 0 00-4.311 2.033 14.634 14.634 0 00-3.353 3.15 14.292 14.292 0 00-2.172 4.074c-.507 1.499-.764 3.094-.771 4.801.014 2.088.396 4.024 1.16 5.807a14.251 14.251 0 003.2 4.67c1.373 1.332 2.984 2.38 4.83 3.143 3.299 1.364 7.723 1.45 11.538.364-2.3-1.9-4.171-3.45-4.56-3.754a22.453 22.453 0 01-.582-.455l-.006-.005c-.28-.228-.557-.464-.83-.71a8.653 8.653 0 01-2.47-.65 9.088 9.088 0 01-4.81-4.822c-.473-1.104-.716-2.298-.723-3.588a9.16 9.16 0 01.715-3.574A8.884 8.884 0 019.407 9.12a8.917 8.917 0 012.86-1.908 9.092 9.092 0 013.477-.687 8.834 8.834 0 013.437.687 8.75 8.75 0 012.804 1.908 8.762 8.762 0 011.895 2.865c.458 1.097.686 2.283.694 3.574-.008 1.29-.236 2.484-.694 3.587a8.944 8.944 0 01-1.895 2.893 8.704 8.704 0 01-2.07 1.573c.532.671 2.053 2.56 3.817 4.76a12.5 12.5 0 001.724-1.067z' fill='%2338A169'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.799 14.058c4.407-.27 8.35 4.514 10.878 7.555 1.822 2.192 11.554 15.169 11.292 15.557-.341.503-8.373-5.375-12.878-9.214a75.27 75.27 0 01-3.163-2.843c-2.908-2.775-6.8-6.273-6.129-11.055z' fill='%2338A169'/%3E%3C/svg%3E"
            alt=""
          />
          <Body>
            <Heading>This is a Quickpage</Heading>
            <Description>
              Within minutes you can create the most unique experience your
              customer has ever seen. A personal video builds trust and rapport
              quickly.{" "}
            </Description>
          </Body>
        </Card>

        <Card active={activeSlide.id === 1} onClick={() => this.setActive(1)}>
          <Icon
            src="data:image/svg+xml,%3Csvg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M26.598 19.218l-8.306-6.038a1.001 1.001 0 00-1.59.808V26.06a.999.999 0 001.59.806l8.306-6.032a.994.994 0 000-1.616z' fill='%23E53E3E'/%3E%3Cpath d='M20 .002c-11.047 0-20 8.953-20 20 0 11.045 8.953 19.995 20 19.995 11.046 0 20-8.952 20-19.994C40.001 8.955 31.046.002 20 .002zm0 36.658c-9.2 0-16.659-7.456-16.659-16.657 0-9.198 7.46-16.663 16.66-16.663 9.199 0 16.657 7.464 16.657 16.663C36.659 29.204 29.2 36.66 20 36.66z' fill='%23E53E3E'/%3E%3C/svg%3E"
            alt=""
          />
          <Body>
            <Heading>Make a play list </Heading>
            <Description>
              Quickly add personal videos, photos, YouTube, PDFs, Docs, all in a
              slider for your customer to click through. Being helpful sets you
              apart.
            </Description>
          </Body>
        </Card>

        <Card active={activeSlide.id === 2} onClick={() => this.setActive(2)}>
          <Icon
            src="data:image/svg+xml,%3Csvg width='36' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.537 17.188c0-.863-.7-1.563-1.562-1.563H7.88a1.562 1.562 0 100 3.125h16.094c.863 0 1.562-.7 1.562-1.563zM7.88 21.875a1.562 1.562 0 100 3.125h9.775a1.562 1.562 0 100-3.125H7.881z' fill='%23805AD5'/%3E%3Cpath d='M11.552 36.875H6.326a3.129 3.129 0 01-3.125-3.125V6.25a3.129 3.129 0 013.125-3.125h19.21a3.129 3.129 0 013.125 3.125v9.61a1.562 1.562 0 103.125 0V6.25A6.257 6.257 0 0025.536 0H6.326a6.257 6.257 0 00-6.25 6.25v27.5A6.257 6.257 0 006.326 40h5.226a1.562 1.562 0 100-3.125z' fill='%23805AD5'/%3E%3Cpath d='M34.555 22.623a4.692 4.692 0 00-6.628-.001l-8.578 8.559a1.562 1.562 0 00-.392.652l-1.868 6.15a1.563 1.563 0 001.912 1.96l6.307-1.747c.26-.072.496-.21.686-.4l8.56-8.544a4.693 4.693 0 000-6.63zM24.078 35.294l-3.173.88.928-3.058 5.789-5.775 2.21 2.21-5.754 5.743zm8.268-8.253l-.302.302-2.21-2.21.302-.3c.609-.61 1.6-.61 2.21 0 .609.609.608 1.6 0 2.208zM23.975 9.375H7.88a1.562 1.562 0 100 3.125h16.094a1.562 1.562 0 100-3.125z' fill='%23805AD5'/%3E%3C/svg%3E"
            alt=""
          />
          <Body>
            <Heading>Add some text</Heading>
            <Description>
              A little bit of text introduces your services.
            </Description>
          </Body>
        </Card>
      </>
    );
  }

  renderCardsRight() {
    const { activeSlide } = this.state;

    return (
      <>
        <Card active={activeSlide.id === 3} onClick={() => this.setActive(3)}>
          <Icon
            src="data:image/svg+xml,%3Csvg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath clip-rule='evenodd' d='M23.333 37.072l8.94-8.112h4.393a1.666 1.666 0 001.667-1.667V3.333a1.667 1.667 0 00-1.667-1.666H3.333a1.667 1.667 0 00-1.667 1.666v23.96a1.667 1.667 0 001.667 1.667h20v8.112z' stroke='%23319795' stroke-width='4'/%3E%3Cpath d='M23.332 8.333H9.999a1.667 1.667 0 100 3.334h13.333a1.667 1.667 0 100-3.334zM31.665 10a1.667 1.667 0 10-3.333 0 1.667 1.667 0 003.333 0z' fill='%23319795'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Cpath fill='%23fff' d='M0 0h40v40H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
            alt=""
          />
          <Body>
            <Heading>A live chat </Heading>
            <Description>
              Each page is equipped with a live chat that will instantly connect
              you to your customer.
            </Description>
          </Body>
        </Card>

        <Card active={activeSlide.id === 4} onClick={() => this.setActive(4)}>
          <Icon
            src="data:image/svg+xml,%3Csvg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)' fill='%23D53F8C'%3E%3Cpath d='M16.666 40c3.019 0 5.544-2.152 6.124-5H10.543c.58 2.848 3.105 5 6.123 5zM29.293 24.16c-.043 0-.083.007-.126.007-7.352 0-13.334-5.982-13.334-13.334 0-2.888.934-5.556 2.5-7.743V1.667a1.666 1.666 0 10-3.333 0v1.8C9.355 4.28 5 9.135 5 15v4.647c0 3.298-1.445 6.411-3.98 8.555A2.912 2.912 0 000 30.417a2.92 2.92 0 002.917 2.916h27.5a2.92 2.92 0 002.916-2.916 2.92 2.92 0 00-1.036-2.229 11.182 11.182 0 01-3.004-4.028z'/%3E%3Cpath d='M29.167 0c-5.973 0-10.833 4.86-10.833 10.833 0 5.974 4.86 10.834 10.833 10.834 5.974 0 10.834-4.86 10.834-10.834C40 4.86 35.14 0 29.167 0zm2.083 13.333a1.25 1.25 0 010 2.5h-4.166c-.69 0-1.25-.56-1.25-1.25v-1.45a3.555 3.555 0 013.55-3.55c.34 0 .616-.276.616-.616a.621.621 0 00-.616-.634h-2.3a1.25 1.25 0 010-2.5h2.3A3.12 3.12 0 0132.5 8.95a3.124 3.124 0 01-3.117 3.133c-.579 0-1.05.472-1.05 1.05v.2h2.916z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Cpath fill='%23fff' d='M0 0h40v40H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
            alt=""
          />
          <Body>
            <Heading>Notifications </Heading>
            <Description>
              Get notified the minute your customer opens your page and get all
              the customer stats to know how engaged they are and how to best
              follow up.{" "}
            </Description>
          </Body>
        </Card>
      </>
    );
  }

  render() {
    const { visible, width } = this.state;
    const mobile = width < 1200;

    return (
      <Section>
        <Contain>
          <QuickpageContain>
            <Slide>
              <IPhone hero>
                <img
                  src="https://s3.amazonaws.com/cdn.quickpageapp.com/public/re-hero.png"
                  alt="Quickpage"
                  onClick={() => this.setState({ visible: true })}
                />
              </IPhone>
            </Slide>

            {mobile ? (
              <>
                <ScrollContainer>
                  <ScrollMobile>
                    {this.renderCardsLeft()}
                    {this.renderCardsRight()}
                  </ScrollMobile>
                </ScrollContainer>

                <CardForm>
                  <IconForm
                    src="data:image/svg+xml,%3Csvg width='64' height='64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)' fill='%2338A169'%3E%3Cpath d='M57.256 59.18a.95.95 0 00.609-1.68L42.711 44.883a.95.95 0 10-1.216 1.46l15.154 12.618c.178.148.393.22.607.22zM21.284 44.883L6.129 57.5a.95.95 0 001.217 1.46L22.5 46.344a.95.95 0 10-1.216-1.46z'/%3E%3Cpath d='M63.993 23.422a.95.95 0 00-.342-.73l-6.692-5.573v-6.1c0-4.324-3.519-7.843-7.844-7.843h-8.904l-.428-.356a12.167 12.167 0 00-15.575 0l-.427.356h-1.922a.95.95 0 100 1.901h27.256a5.95 5.95 0 015.943 5.943v17.813l-16.491 13.73a10.266 10.266 0 01-13.142 0l-16.49-13.73V17.561 11.02a5.95 5.95 0 015.945-5.943h3.178a.95.95 0 000-1.9H14.88c-4.326 0-7.845 3.518-7.845 7.843v6.1L.343 22.691a.949.949 0 00-.342.722L0 23.422V57.09a6.92 6.92 0 006.912 6.912h42.572a.95.95 0 100-1.9H6.912A5.016 5.016 0 011.9 57.09V25.45l5.479 4.562 16.828 14.012a12.143 12.143 0 007.789 2.819c2.765 0 5.53-.94 7.786-2.819l16.826-14.01a.136.136 0 00.008-.006l5.475-4.558v31.639a5.016 5.016 0 01-5.011 5.01h-3.796a.95.95 0 100 1.902h3.796a6.92 6.92 0 006.911-6.912v-33.66-.007zM36.948 3.176h-9.903a10.27 10.27 0 019.903 0zM7.035 19.593v7.658l-4.599-3.829 4.599-3.829zm49.924 7.657v-7.657l4.598 3.829-4.598 3.828z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M38.53 28.106a9.812 9.812 0 002.114-2.13 9.53 9.53 0 001.363-2.685c.319-.979.478-2.013.483-3.114a10.121 10.121 0 00-.52-3.227 9.632 9.632 0 00-1.467-2.749 9.69 9.69 0 00-2.263-2.131 10.54 10.54 0 00-2.91-1.377 11.887 11.887 0 00-3.41-.492 11.879 11.879 0 00-3.41.487 10.526 10.526 0 00-2.91 1.373 9.872 9.872 0 00-2.264 2.126 9.646 9.646 0 00-1.466 2.75 10.175 10.175 0 00-.52 3.24c.009 1.41.267 2.717.782 3.92a9.62 9.62 0 002.16 3.152c.928.9 2.015 1.607 3.261 2.122 2.226.92 5.213.978 7.788.246-1.553-1.283-2.815-2.33-3.078-2.535-.132-.099-.262-.201-.393-.306l-.004-.004a14.294 14.294 0 01-.56-.48 6.066 6.066 0 01-3.598-1.741 6.165 6.165 0 01-1.804-4.374 6.183 6.183 0 01.483-2.412 5.997 5.997 0 011.311-1.934 6.02 6.02 0 014.278-1.752c.83.005 1.602.16 2.32.464.716.309 1.349.735 1.892 1.288a5.914 5.914 0 011.28 1.934c.309.74.463 1.541.468 2.412a6.339 6.339 0 01-.469 2.421 6.037 6.037 0 01-2.677 3.015c.36.453 1.386 1.728 2.577 3.213a8.459 8.459 0 001.164-.72z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M30.66 19.164c2.976-.182 5.637 3.047 7.344 5.1 1.23 1.479 7.798 10.239 7.622 10.5-.23.34-5.652-3.627-8.693-6.219a50.774 50.774 0 01-2.135-1.919c-1.962-1.873-4.59-4.234-4.137-7.462z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Cpath fill='%23fff' d='M0 0h64v64H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
                    alt=""
                  />
                  <FormHeading>
                    Get your example <strong>Quickpage</strong> now!!!
                  </FormHeading>
                  <FormCTA onClick={() => this.setState({ visible: true })}>
                    Send Me a Quickpage
                  </FormCTA>
                </CardForm>
              </>
            ) : (
              <Row>
                <Col>{this.renderCardsLeft()}</Col>

                <Col>
                  {this.renderCardsRight()}

                  <CardForm>
                    <IconForm
                      src="data:image/svg+xml,%3Csvg width='64' height='64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)' fill='%2338A169'%3E%3Cpath d='M57.256 59.18a.95.95 0 00.609-1.68L42.711 44.883a.95.95 0 10-1.216 1.46l15.154 12.618c.178.148.393.22.607.22zM21.284 44.883L6.129 57.5a.95.95 0 001.217 1.46L22.5 46.344a.95.95 0 10-1.216-1.46z'/%3E%3Cpath d='M63.993 23.422a.95.95 0 00-.342-.73l-6.692-5.573v-6.1c0-4.324-3.519-7.843-7.844-7.843h-8.904l-.428-.356a12.167 12.167 0 00-15.575 0l-.427.356h-1.922a.95.95 0 100 1.901h27.256a5.95 5.95 0 015.943 5.943v17.813l-16.491 13.73a10.266 10.266 0 01-13.142 0l-16.49-13.73V17.561 11.02a5.95 5.95 0 015.945-5.943h3.178a.95.95 0 000-1.9H14.88c-4.326 0-7.845 3.518-7.845 7.843v6.1L.343 22.691a.949.949 0 00-.342.722L0 23.422V57.09a6.92 6.92 0 006.912 6.912h42.572a.95.95 0 100-1.9H6.912A5.016 5.016 0 011.9 57.09V25.45l5.479 4.562 16.828 14.012a12.143 12.143 0 007.789 2.819c2.765 0 5.53-.94 7.786-2.819l16.826-14.01a.136.136 0 00.008-.006l5.475-4.558v31.639a5.016 5.016 0 01-5.011 5.01h-3.796a.95.95 0 100 1.902h3.796a6.92 6.92 0 006.911-6.912v-33.66-.007zM36.948 3.176h-9.903a10.27 10.27 0 019.903 0zM7.035 19.593v7.658l-4.599-3.829 4.599-3.829zm49.924 7.657v-7.657l4.598 3.829-4.598 3.828z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M38.53 28.106a9.812 9.812 0 002.114-2.13 9.53 9.53 0 001.363-2.685c.319-.979.478-2.013.483-3.114a10.121 10.121 0 00-.52-3.227 9.632 9.632 0 00-1.467-2.749 9.69 9.69 0 00-2.263-2.131 10.54 10.54 0 00-2.91-1.377 11.887 11.887 0 00-3.41-.492 11.879 11.879 0 00-3.41.487 10.526 10.526 0 00-2.91 1.373 9.872 9.872 0 00-2.264 2.126 9.646 9.646 0 00-1.466 2.75 10.175 10.175 0 00-.52 3.24c.009 1.41.267 2.717.782 3.92a9.62 9.62 0 002.16 3.152c.928.9 2.015 1.607 3.261 2.122 2.226.92 5.213.978 7.788.246-1.553-1.283-2.815-2.33-3.078-2.535-.132-.099-.262-.201-.393-.306l-.004-.004a14.294 14.294 0 01-.56-.48 6.066 6.066 0 01-3.598-1.741 6.165 6.165 0 01-1.804-4.374 6.183 6.183 0 01.483-2.412 5.997 5.997 0 011.311-1.934 6.02 6.02 0 014.278-1.752c.83.005 1.602.16 2.32.464.716.309 1.349.735 1.892 1.288a5.914 5.914 0 011.28 1.934c.309.74.463 1.541.468 2.412a6.339 6.339 0 01-.469 2.421 6.037 6.037 0 01-2.677 3.015c.36.453 1.386 1.728 2.577 3.213a8.459 8.459 0 001.164-.72z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M30.66 19.164c2.976-.182 5.637 3.047 7.344 5.1 1.23 1.479 7.798 10.239 7.622 10.5-.23.34-5.652-3.627-8.693-6.219a50.774 50.774 0 01-2.135-1.919c-1.962-1.873-4.59-4.234-4.137-7.462z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Cpath fill='%23fff' d='M0 0h64v64H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
                      alt=""
                    />
                    <FormHeading>
                      Get your example <strong>Quickpage</strong> now!!!
                    </FormHeading>
                    <FormCTA onClick={() => this.setState({ visible: true })}>
                      Send Me a Quickpage
                    </FormCTA>
                  </CardForm>
                </Col>
              </Row>
            )}

            {visible && (
              <Portal
                onClicked={() => this.setState({ visible: false })}
                small={true}
              >
                <Form />
              </Portal>
            )}
          </QuickpageContain>
        </Contain>
      </Section>
    );
  }
}
